import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useQuery } from '@tanstack/react-query';
import { Select } from '@/components/ui';
import { api } from '@/lib/api';
/** Currency picker backed by /currencies/ (full ISO-4217 list, seeded by
 *  `manage.py seed_currencies`). */
export function CurrencySelect({ value, onChange, disabled, placeholder, allowEmpty, className }) {
    const q = useQuery({
        queryKey: ['currencies'],
        queryFn: async () => (await api.get('/currencies/')).data,
        staleTime: 24 * 60 * 60 * 1000,
    });
    return (_jsxs(Select, { value: value, disabled: disabled || q.isLoading, onChange: (e) => onChange(e.target.value), className: className, children: [(allowEmpty || !value) && _jsx("option", { value: "", children: placeholder ?? '— select currency —' }), q.data?.map((c) => (_jsxs("option", { value: c.code, children: [c.code, " \u2014 ", c.name] }, c.code)))] }));
}
